import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ name, project, initialComment }) =>
    present(
      repository
        .createDiscussion(name, project)
        .then((discussion) =>
          repository
            .saveComment(discussion, initialComment)
            .then((comment) => ({
              discussion: {
                ...discussion,
                comments: [...discussion.comments, comment],
              },
              project,
              name,
            }))
            .catch(() =>
              repository
                .removeDiscussion(discussion)
                .then(() => Promise.reject({ name, project, initialComment })),
            ),
        )
        .catch(() => Promise.reject({ name, project, initialComment })),
    );
}

export type { Interactor };

export { createInteractor };
